import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AssignmentListComponent } from '@app/pages/admin/components/assignment-list/assignment-list';

@Component({
  selector: 'app-assignments-page',
  standalone: true,
  imports: [TranslateModule, AssignmentListComponent],
  templateUrl: './assignments-page.html',
  styleUrl: './assignments-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentsPageComponent {}
